import { render, staticRenderFns } from "./lista.vue?vue&type=template&id=a0fca392"
import script from "./lista.vue?vue&type=script&lang=js"
export * from "./lista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports